<div class="voucher-loading" aria-live="polite" [attr.aria-label]="label">
  <div class="loading-card loading-card-form">
    <div class="loading-line loading-title"></div>
    <div class="loading-line"></div>
    <div class="loading-line loading-short"></div>
    <div class="loading-fields">
      <div class="loading-field"></div>
      <div class="loading-field"></div>
    </div>
    <div class="loading-field"></div>
    <div class="loading-field"></div>
    <div class="loading-button"></div>
  </div>
  <div class="loading-side">
    <div class="loading-card">
      <div class="loading-line loading-title"></div>
      <div class="loading-line"></div>
      <div class="loading-line loading-short"></div>
      <div class="loading-line"></div>
    </div>
    <div class="loading-card loading-help">
      <div class="loading-line loading-title"></div>
      <div class="loading-line"></div>
    </div>
  </div>
</div>